<template>
  <div class="
    cruise-info 
    tw-flex 
    tw-justify-center 
    tw-pt-5 
    tw-pb-2
    2xl:tw-pt-6 
    2xl:tw-pb-3">
    <div
      v-for="data in dataCruiseInfo"
      :key="data.id"
      class="
        tw-text-xs
        tw-flex tw-items-center tw-font-normal
        tw-mr-6
        2xl:tw-mr-10
      "
    >
      <img
        :src="getIconSrc(data.iconName)"
        :alt="data.iconName"
        class="tw-mr-1.5 tw-w-2.5 2xl:tw-w-3.5"
      />
      <span v-if="data.name">{{ data.name }}:&nbsp;</span>
      <span>{{ data.details }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CruiseInfo",
  props: {
    dataCruiseInfo: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getIconSrc(name) {
      return require("@/assets/icons/" + name + ".svg")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "CruiseInfo"
</style>
